import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuraImageComponent, ImageConfig } from '@sura-ui/atoms';
import { ProgressSpinner } from 'primeng/progressspinner';

/**
 * Componente de pantalla de carga (splash screen) que se muestra al iniciar la aplicación.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-splash',
  imports: [CommonModule, SuraImageComponent, ProgressSpinner],
  template: `
    @if (canShow()) {
      <div
        class="fixed inset-0 z-[9999] flex h-screen justify-center items-center font-bold bg-white"
      >
        <div class="flex flex-col justify-center items-center">
          <div class="w-32 h-12 flex items-center justify-center mb-6">
            <sura-image
              [config]="getSplashImageConfig()"
              class="max-w-full max-h-full girop-logo-tint"
              (imageError)="onImageError()"
            ></sura-image>
          </div>
          <p-progress-spinner
            [style]="{ width: '40px', height: '40px' }"
            strokeWidth="4"
            animationDuration=".8s"
            styleClass="girop-spinner"
          ></p-progress-spinner>
          <span class="text-sm text-gray-500 mt-4">Cargando...</span>
        </div>
      </div>
    }
  `,
  styles: []
})
export class AppSplashComponent implements OnInit {
  /**
   * Indica si la pantalla de carga debe mostrarse o no.
   * @type {boolean}
   */
  protected canShow = signal(true);

  /**
   * URL de la imagen del splash
   */
  protected imageSrc = signal('assets/images/girop-logo.png');

  /**
   * Tiempo en milisegundos que la pantalla de carga se mostrará antes de ocultarse.
   * @type {number}
   */
  private timeToHide = 3000;

  ngOnInit() {
    setTimeout(() => {
      this.canShow.set(false);
    }, this.timeToHide);
  }

  /**
   * Configuración de la imagen del splash screen.
   */
  getSplashImageConfig(): ImageConfig {
    return {
      src: this.imageSrc(),
      alt: 'SURA Logo',
      width: 128,
      height: 48,
      objectFit: 'contain'
    };
  }

  /**
   * Maneja errores de carga de imagen mostrando una imagen por defecto
   */
  onImageError(): void {
    this.imageSrc.set(
      'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI1NiIgdmlld0JveD0iMCAwIDI1NiAyNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiBmaWxsPSIjRjNGNEY2IiByeD0iMTYiLz4KPHN2ZyB4PSI2NCIgeT0iNjQiIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9IiM2MzY2RjkiPgo8cGF0aCBkPSJNMTIgMkw3IDlIM1YxNkgxNFYxOUgxMFYyMUgxNFYyMkgzVjlMMTIgMloiLz4KPHN2ZyB4PSI4OCIgeT0iMTQ0IiB3aWR0aD0iODAiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAxNjAgNjQiIGZpbGw9IiM2MzY2RjkiPgo8dGV4dCB4PSI4MCIgeT0iNDAiIGZvbnQtZmFtaWx5PSJzYW5zLXNlcmlmIiBmb250LXNpemU9IjI0IiBmb250LXdlaWdodD0iYm9sZCIgZmlsbD0iIzYzNjZGOSIgdGV4dC1hbmNob3I9Im1pZGRsZSI+Uk9DS0VUPC90ZXh0Pgo8L3N2Zz4KPC9zdmc+Cjwvc3ZnPgo='
    );
  }
}
